import type { ColorPalette } from '@/features/colors/color.types';
import {
  NEUTRAL_COOL,
  NEUTRAL_GRAY,
  NEUTRAL_WARM,
} from '@/features/colors/neutrals';

// colorN == the default category the server seeds at sortOrder N
// (defaultCategories.json), though the shade.500 hexes have since been
// updated by design and no longer match the seeded values exactly.
//
// Slots in design's column order: pink, orange, yellow, tan, green, blue,
// purple, gray — note tan is color6, not color3. Shades by role: 500 primary
// accent, 300 muted, 100 light category, 50 shaded cell.
export const joyfulPalette: ColorPalette = {
  id: 'joyful',
  name: 'Joyful',
  description: 'Bright & cheerful',
  colors: {
    cool: { ...NEUTRAL_COOL },
    gray: { ...NEUTRAL_GRAY },
    warm: { ...NEUTRAL_WARM },
    color0: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FFECF4',
        '100': '#FBE3EF',
        '300': '#E887B7',
        '500': '#D5257C',
      },
    },
    color1: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FFEFE6',
        '100': '#FCE9E0',
        '300': '#F6AE8A',
        '500': '#EF6C2A',
      },
    },
    color2: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FFF2CE',
        '100': '#FEF9E8',
        '300': '#FBE193',
        '500': '#F8C83A',
      },
    },
    color3: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#ECF6F3',
        '100': '#E4EDEC',
        '300': '#84B5AC',
        '500': '#207868',
      },
    },
    color4: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#E9F5FF',
        '100': '#E6F0FB',
        '300': '#8BBEEA',
        '500': '#2C88D9',
      },
    },
    color5: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#F7F0FD',
        '100': '#EAE6FC',
        '300': '#B69ECA',
        '500': '#7A4E9E',
      },
    },
    color6: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#F9F2EA',
        '100': '#F3EBDB',
        '300': '#D2BA96',
        '500': '#BC9055',
      },
    },
    color7: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#CDCDCE',
        '100': '#E3E3E3',
        '300': '#8A8A8A',
        '500': '#5A5A5C',
      },
    },
  },
};
